import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TActivity from './Tables/TActivity';
import styles from 'src/components/Admin/Result/Results.module.scss';
import { Breadcrumb } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
const Activities: React.FC = () => {
    interface RouteParams {
        idGei: string;
        idOrganization: string;
    }
    const params = useParams<RouteParams>();
    const history = useHistory();
    return (
        <div>    
             <div>
                <br />
                <div className={styles["admin-header"]}>
                    <div >
                        <span className={styles["header"]} onClick={() => history.push("/gei-inventory")}> Inventario GEI</span>
                        <span> / </span><span className={styles["header"]} onClick={() => history.push(`/establishment/gei/${params.idGei}/${params.idOrganization}`)} >Establecimientos</span>
                        <span> / </span><span className={styles["header-bold"]}>Data de actividad</span>
                    </div>
                </div>
                <br />
            </div>
         <TActivity/>
          
     </div>

    );
};
export default Activities;